function setupCarReservationListener() {
    window.removeEventListener('carReservationSaved', carReservationSavedHandler);

    function carReservationSavedHandler(event) {
        let successMessage = document.getElementById('car-reservation-form')?.dataset.success || 'Reservation successful!';
        let flashMessageHtml =
            '<div class="alert alert-success" onclick="$(this).remove();event.preventDefault();">' +
            '<img src="/images/icons/ico-alert-success.svg" alt="" class="icon icon--w32 flex-shrink-0">' +
            '<div>' +
            '<h5 class="h5 alert__title">' + successMessage + '</h5>' +
            '</div>' +
            '</div>';
        $('main').append(flashMessageHtml);

        // Hide modal and ensure backdrop is removed
        $('#modalTestDrive').modal('hide');

        // Force remove backdrop and body class after modal animation
        setTimeout(function() {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('body').css('padding-right', '');
        }, 300);
    }

    window.addEventListener('carReservationSaved', carReservationSavedHandler);
}

document.addEventListener('DOMContentLoaded', setupCarReservationListener);
document.addEventListener('livewire:navigated', setupCarReservationListener);
